module.exports = __webpack_public_path__ + "static/img/cruelty_child_1_sc.aeaecb89.png";